export const platformAdminBaseUrl = '/platform-admin/v1';

export const voiceBaseUrl = '/voice-settings-orchestration';

export const iamOrchestrationBaseUrl = '/iam';

export const billingServiceBaseUrl = '/platform-billing-orchestration';

export const accountBaseUrl = '/account';
